import { useQuery } from '@tanstack/react-query';
import {
  RfiOverviewDto,
  OverviewStepDto,
  OverviewWorkflowDto,
} from 'src/api/FiretrolApiClient';
import { rfisOverviewApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type { RfiOverviewDto, OverviewStepDto, OverviewWorkflowDto };

export function useRfisOverview() {
  return useQuery({
    queryKey: queryKeys.rfis.overview(),
    queryFn: ({ signal }) =>
      rfisOverviewApiClient.getRfis(toCancelToken(signal)),
    meta: {
      errorContext: 'rfis overview',
    },
  });
}
